import { render, staticRenderFns } from "./SQLDatabaseDetails.vue?vue&type=template&id=4189812c&"
import script from "./SQLDatabaseDetails.vue?vue&type=script&lang=ts&"
export * from "./SQLDatabaseDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports